import { Accordion, AccordionDetails } from '@material-ui/core';
import React, { FC, ReactNode, useState } from 'react';
import { FontAwesomeSpriteButton } from '../FontAwesomeLocal';
import { NotificationDialog } from '../Dialog';
import { StyledAccordionSummary, StyledMuiButton } from './Atoms';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type Props = {
  activated?: boolean;
  children?: ReactNode;
};

const AlgebraKitSolution: FC<Props> = ({ activated = false, children = undefined }) => {
  const [expanded, setExpanded] = useState(false);
  const [notificationOpened, setNotificationOpened] = useState(false);
  return (
    <>
      <NotificationDialog
        open={notificationOpened}
        onClose={() => setNotificationOpened(false)}
        description="Verzend eerst een antwoord om de oplossing te bekijken."
        confirmationText="SLUIT"
      />
      <Accordion
        expanded={expanded}
        elevation={0}
        style={{ borderTop: expanded ? '1px solid rgba(0.1, 0, 0, 0.1)' : undefined }}
      >
        <StyledAccordionSummary
          aria-controls="ak-solution-panel-content"
          id="ak-solution-panel-header"
        >
          <>
            {!expanded && (
              <StyledMuiButton
                variant={!activated ? 'text' : 'contained'}
                onClick={!activated ? () => setNotificationOpened(true) : () => setExpanded(true)}
                style={!activated ? { color: '#968E82', background: 'transparent' } : undefined}
              >
                OPLOSSING
              </StyledMuiButton>
            )}
            {expanded && activated && (
              <>
                <p>OPLOSSING</p>
                <FontAwesomeSpriteButton
                  onClick={() => setExpanded(false)}
                  buttonStyle={{ marginLeft: 'auto', padding: 5 }}
                  icon={SpriteIconsLight.XMARK}
                  iconSize="lg"
                  color="black"
                />
              </>
            )}
          </>
        </StyledAccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </>
  );
};

export default AlgebraKitSolution;
